import {
    SUCCESS_GET_AUDIT_TABLES,
    FAILED_GET_AUDIT_TABLES,
    SUCCESS_GET_AUDIT_LOGS,
    FAILED_GET_AUDIT_LOGS,
    CLEAR_AUDIT_LOGS,
    SET_AUDIT_FILTERS,
    CLEAR_AUDIT_FILTERS,
    SET_AUDIT_LOADING,
} from '../constants/auditLogConstants';

const initialState = {
    tables: [],
    auditLogs: [],
    pagination: {
        page: 1,
        page_size: 50,
        total_count: 0,
        total_pages: 0,
        has_next: false,
        has_previous: false,
    },
    filters: {
        table_name: '',
        date_from: '',
        date_to: '',
        updated_by: '',
        tracking_id: '',
        action_type: '',
        search: '',
    },
    loading: false,
    errorMessage: '',
};

export default (state = initialState, action) => {
    switch (action.type) {
        case SUCCESS_GET_AUDIT_TABLES:
            return {
                ...state,
                tables: action.payload.tables || [],
                errorMessage: '',
            };

        case FAILED_GET_AUDIT_TABLES:
            return {
                ...state,
                tables: [],
                errorMessage: action.errorMessage,
            };

        case SUCCESS_GET_AUDIT_LOGS:
            return {
                ...state,
                auditLogs: action.payload.results || [],
                pagination: action.payload.pagination || initialState.pagination,
                loading: false,
                errorMessage: '',
            };

        case FAILED_GET_AUDIT_LOGS:
            return {
                ...state,
                auditLogs: [],
                pagination: initialState.pagination,
                loading: false,
                errorMessage: action.errorMessage,
            };

        case CLEAR_AUDIT_LOGS:
            return {
                ...state,
                auditLogs: [],
                pagination: initialState.pagination,
            };

        case SET_AUDIT_FILTERS:
            return {
                ...state,
                filters: action.payload,
            };

        case CLEAR_AUDIT_FILTERS:
            return {
                ...state,
                filters: initialState.filters,
                auditLogs: [],
                pagination: initialState.pagination,
            };

        case SET_AUDIT_LOADING:
            return {
                ...state,
                loading: action.payload,
            };

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// src/state/reducers/auditLogReducer.js